import React from 'react';
import {Store} from '../../models/store.model';
import {KSA_CITIES} from '../../../../constants/ksaCities';
import {SearchableSelect} from '../../../../Presentation/components/ui/SearchableSelect';

interface StoreContactFieldsProps {
  formData: Partial<Store>;
  onInputChange: (field: keyof Store, value: string) => void;
}

export const StoreContactFields: React.FC<StoreContactFieldsProps> = ({
  formData,
  onInputChange
}) => {
  const selectedCity = formData.city || '';
  const districts = KSA_CITIES[selectedCity] ?? [];

  const handleCityChange = (city: string) => {
    onInputChange('city', city);
    onInputChange('region', '');
  };

  return (
    <>
      {/* Phone Number */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          رقم الهاتف
        </label>
        <input
          type="tel"
          value={formData.phoneNumber || ''}
          onChange={(e) => onInputChange('phoneNumber', e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-brand-500"
          placeholder="أدخل رقم الهاتف"
        />
      </div>

      {/* City */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          المدينة
        </label>
        <SearchableSelect
          value={selectedCity}
          options={Object.keys(KSA_CITIES)}
          onChange={handleCityChange}
          placeholder="اختر المدينة"
        />
      </div>

      {/* Region (District) */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          الحي
        </label>
        <SearchableSelect
          value={formData.region || ''}
          options={districts}
          onChange={(value) => onInputChange('region', value)}
          disabled={!selectedCity}
          placeholder="اختر الحي"
          disabledPlaceholder="اختر المدينة أولاً"
        />
      </div>
    </>
  );
};
